/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 新增或者修改我的观演人
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  viewer: member.Viewer,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/viewer`,
    data: viewer,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
